/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const TruckCabCrew = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 121 73" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M65.9.8L44.4 20S5 22.4 5 36.3v.8h9.8c.8 0 1.4.7 1.4 1.4v1.3c0 .8-.7 1.4-1.4 1.4H5v5.9h17.8c6.6-7.1 17.7-7.6 24.9-1l1 1h71.9V.9L65.9.8zm1.8 5.4h17.5v15.4H50.9L67.7 6.2zm17.6 23.1H74.5v-2.1h10.8v2.1zm6.3-22.9h22.6v15.2H91.7l-.1-15.2zm22.7 22.9h-10.8v-2.1h10.8v2.1zM1.4 50.3c-.8.2-1.4.8-1.4 1.7v6.2c0 .9.9 1.7 1.9 1.7h15.7v-.8c0-3.1.8-6.1 2.4-8.8H1.4zM52.8 59.1v.8h67.8v-9.7H50.4c1.5 2.8 2.4 5.8 2.4 8.9z" /><circle cx="35.3" cy="59" r="13.7" /></g>
      </g>
    </svg>
  </span>
);

TruckCabCrew.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

TruckCabCrew.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default TruckCabCrew;
